import React from 'react';
import { ReactMultiEmail } from 'react-multi-email';
import 'react-multi-email/dist/style.css';
export const EmailInput = ({ placeholder, value, onValueChange }) => {
    return (React.createElement(ReactMultiEmail, { placeholder: placeholder || 'Input your email', emails: value, className: '!onvo-border-slate-200 dark:!onvo-border-slate-800 onvo-text-slate-900 dark:onvo-text-slate-50 !onvo-bg-white dark:!onvo-bg-slate-950 !onvo-py-0 !onvo-text-sm', onChange: (_emails) => {
            onValueChange(_emails);
        }, inputClassName: '!onvo-shadow-none !onvo-text-slate-900 dark:!onvo-text-slate-50 !onvo-bg-white dark:!onvo-bg-slate-950 !onvo-text-sm', getLabel: (email, index, removeEmail) => {
            return (React.createElement("div", { "data-tag": true, key: index },
                React.createElement("div", { "data-tag-item": true }, email),
                React.createElement("span", { "data-tag-handle": true, onClick: () => removeEmail(index) }, "\u00D7")));
        } }));
};
//# sourceMappingURL=EmailInput.js.map